import { useApolloClient } from '@apollo/client';
import { seoProductInfo } from '@catalogo/service-americanas-product/src/queries/seo-product-info.graphql';
import { SocialInfo } from './types';

export const useSeoSocialInfo = (): SocialInfo => {
  const client = useApolloClient();

  try {
    const result = client.readQuery({
      query: seoProductInfo,
    });

    return {
      title: result?.title || '',
      description: result?.description || '',
      socialImagesData: result?.socialImages || {},
    };
  } catch (e) {
    return { title: '', description: '', socialImagesData: [] };
  }
};
